import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'

const [w] = [window]

export default function HOME() {
  // map script
  // const km = w.siteinfo.mapApiKeys
  // const env_map_key = (!km[host]) ? km['local'] : km[host]
  // w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})

  $(() => {
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'topics':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr: {
            class: 'button button-inverse c-btn-icon-right'
          }
        },
        title:{
          html: '<span>NEWS</span><small>新着情報</small>' // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          $this
            .append( $title.append($new) )
            .append( $catetitle )
            .append( $date )
            .append( $catch )
            .append( $body );
          // $date.insertAfter( $catetitle );
        }
      },
      // 'works':{
      //   title:{
      //     html: '<span>WORKS</span><small>施工事例</small>' // プレーンテキストで動的にする場合は false
      //   },
      //   itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
      //     $this
      //       .append( $title.append($new) )
      //       .append( $catetitle )
      //       .append( $date )
      //       .append( $catch )
      //       .append( $body );
      //     // $date.insertAfter( $catetitle );
      //   }
      // },
    }));
  
    // ticker
    w.load['mainvisual'].done(() => {
      /*****
     * Slick実行
     */
      $('[data-plugin="slider"]').slick({
        autoplay:true,
        fade: true,
        dots: true,
        speed: 1200,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        responsive: [{
          breakpoint: 768,
          settings: {
            dots: false
          }
        }]
      });

      // スクロールボタンをクリックで画面の高さ分スクロール
      $('.p-mainvisual__scroll').on('click',()=>{
        // const height = $(window).innerHeight()
        const height = $(window).innerHeight()
        $('body,html').animate({scrollTop: height },'slow','easeInOutExpo')
        return false
      });

      GET_ARTICLES('.p-mainvisual__ticker [data-plugin="getArticles"]',{
        makeItem(item,opt){
          const body_len = ($.UA.is_mobile)? 40:31
          return $(`
          <a href="${item.href}" class="p-mainvisual__ticker__item">
            <figure class="thumb">
              <div class="thumb-img" style="background-image:url('${item.thumb}')">
                <img src="${item.thumb}" width="180" alt="${item.title}">
              </div>
            </figure>
            <div class="body">
              <span class="date">${item.date}</span>
              <h5 class="title">${item.title}</h5>
              <p class="desc">${$.strip_tags(item.body).str_truncate(body_len)}</p>
            </div>
          </a>
        </div>`)[0]
        }
      });
    })

    w.load['block-news'].done(() => {
      GET_ARTICLES('.p-block-news [data-plugin="getArticles"]',{
        makeItem(item){
          const body_len = ($.UA.is_mobile)? 37:50
          return $(`
          <a href="${item.href}" class="p-block-news__item">
            <span class="date">${item.date}</span>
            <span class="category button-secondary">${item.category.name}</span>
            <div class="body">
              <p class="title">${item.title}</p>
              <p class="desc">${$.strip_tags(item.body).str_truncate(body_len)}</p>
            </div>
          </a>
          `)[0]
        }
      })
    })

  
  });

}